import React, { Component } from 'react';
import CN from 'classnames';
import { Icon } from 'elements';

import './Psychic.css';


export default class Psychic extends Component {

  static propTypes = {
    psychic: React.PropTypes.object,
    selectedUUID: React.PropTypes.string,
    clickFunction: React.PropTypes.func
  };

  state = {
    psychic: this.props.psychic
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  get isSelected() {
    return this.props.selectedUUID === this.props.psychic.uuid;
  }

  render() {
    const psychic = this.props.psychic;
    return (
      <div
        className="psychic-row"
        onClick={ () => this.props.clickFunction(this.props.psychic) }
      >
        <div >
          <span className={ CN('unread-thread-dot', { 'invisible-dot': true }) } >&#9679;</span >
          <span
            className={ CN('psychic-info', { 'selected-psychic': this.isSelected }) }
          >
            { psychic.name }, { psychic.email }
          </span >
          <span className={ CN('float-right conv-status', { 'unread-conv': psychic.unconvs }) } >
            {
              psychic.hasUnansweredPaidConv &&
              <span className="payed-sign">$</span >
            }
            { psychic.unconvs } / { psychic.convs }
          </span >

        </div >
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/psychic/Psychic.jsx